import styled, { css } from 'styled-components'
import { Link } from 'react-router-dom'

export const StyledTableCellIcon = styled.div`
    ${({ sortDirect }) =>
        sortDirect === 'asc' &&
        css`
          transform: rotate(90deg);
        `
    };
    ${({ sortDirect }) =>
        sortDirect === 'desc' &&
        css`
          transform: rotate(-90deg);
        `
    };
`

export const StyledTableCell = styled.div`
    position: relative;
    flex: 1;
    font-size: 14px;
    letter-spacing: 0.5px;
    margin-right: 20px;
    ${({ pointer }) =>
        pointer &&
        css`
          cursor: pointer;
        `
    };
    ${({ active }) =>
        active &&
        css`
          &:after {
              content: '';
              display: block;
              position: absolute;
              left: 0;
              bottom: -16px;
              width: 100%;
              height: 1px;
              background-color: ${({ theme }) => theme.grassyGreen};
          }
        `
    };
`

export const StyledTableRow = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    padding-top: 15px;
    padding-bottom: 15px;
    ${({ hover }) =>
        hover &&
        css`
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            background-color: ${({ theme }) => theme.white};
          }
        `
    };
`

export const StyledLink = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    left: 0;
    width: 100%;
    height: 100%;
`

export const StyledTableHead = styled.div`
    ${StyledTableRow} {
        padding-top: 0;
    }

    ${StyledTableCell} {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        font-size: 15px;
        font-weight: ${({ theme }) => theme.fontWeight.bold}
    }
`

export const StyledTableBody = styled.div`
`

export const StyledTable = styled.div`
    overflow-x: auto;
`

export const StyledTableContainer = styled.div`
`